type Props = {
  fill?: string;
  height?: string;
  width?: string;
};
const StarFull = ({ height = '100%', fill, width = '100%' }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 1L10.0572 5.16844L14.6574 5.83688L11.3287 9.08156L12.1145 13.6631L8 11.5L3.8855 13.6631L4.6713 9.08156L1.3426 5.83688L5.94275 5.16844L8 1Z"
        fill={fill}
      />
    </svg>
  );
};

export default StarFull;
